import { Catalog } from '@/types/Catalog';
import { ItemSummary } from '@/types/item/ItemSummary';
import { ReviewComment, ReviewResponse } from '@/types/Review';
import { Seller } from '@/types/Seller';

import { ReviewedPageComments } from './ReviewedPageComments';
import { ReviewedPageHeader } from './ReviewedPageHeader';
import { ReviewedPageRatings } from './ReviewedPageRatings';

type Props = {
    baseUrl: string;
    catalog: Catalog;
    completedReview: ReviewResponse;
    items: ItemSummary[];
    reviewComments: ReviewComment[];
    seller: Seller;
};

export const ReviewedPage = ({ baseUrl, catalog, completedReview, items, reviewComments, seller }: Props) => {
    return (
        <div className="mx-auto max-w-[1240px] pr-md pb-lg">
            <ReviewedPageHeader
                baseUrl={baseUrl}
                catalog={catalog}
                completedReview={completedReview}
                items={items}
            />
            <ReviewedPageRatings completedReview={completedReview} />
            <ReviewedPageComments
                completedReview={completedReview}
                reviewComments={reviewComments}
                seller={seller}
            />
        </div>
    );
};
